import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Crew from './pages/Crew';
import Shop from './pages/Shop';
import About from './pages/About';
import Academy from './pages/Academy';
import Header from './components/Header';
import Footer from './components/Footer'
import Cart from './components/Cart';
import Account from './components/Account';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
  <Router>
    <ScrollToTop />
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/crew" element={<Crew />} />
      <Route path="/academy" element={<Academy />} />
      <Route path="/about" element={<About />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/account" element={<Account />} />
      <Route path="/cart" element={<Cart />} />
    </Routes>
    <Footer />
  </Router>
  );
}

export default App;